import { render } from "./ProductCenterHomePage.vue?vue&type=template&id=3d9f0e41&scoped=true"
import script from "./ProductCenterHomePage.vue?vue&type=script&lang=js"
export * from "./ProductCenterHomePage.vue?vue&type=script&lang=js"

import "./ProductCenterHomePage.vue?vue&type=style&index=0&id=3d9f0e41&lang=scss&scoped=true"

import exportComponent from "E:\\developYZ\\yzWebsite\\newWebsite\\my-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9f0e41"]])

export default __exports__